import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useBenchmarksSection from './useBenchmarksSection';

import styles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/checkboxFilter.module.scss';

const Benchmarks = () => {
  const { items, selectedValues, isAllSelected, isIndeterminate, toggle, toggleAll } = useBenchmarksSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Benchmarks }
      header={ (
        <FilterSectionHeader
          title="BENCHMARK"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="benchmarksFiltersAllCheckbox"
            />
          ) }
        />
      ) }
    >
      <div className={ styles.columns2 }>
        { items.map((item) => (
          <FilterItem key={ item.value } isExpandable={ false }>
            <Checkbox
              label={ item.name }
              checked={ selectedValues.includes(item.value) }
              onChange={ () => toggle(item.value) }
              dataTest={ `checkbox-benchmark-${ item.value }` }
            />
          </FilterItem>
        )) }
      </div>
    </FilterSection>
  );
};

export default Benchmarks;
